import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { DevicesPage } from './pages/DevicesPage';
import { RequestsPage } from './pages/RequestsPage';
import { LogsPage } from './pages/LogsPage';

/**
 * Route table for the operator UI. All pages render inside the shared
 * {@link Layout}.
 */
export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<DevicesPage />} />
        <Route path="requests" element={<RequestsPage />} />
        <Route path="logs" element={<LogsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
